/** Match OMS/Lodge helpers.formatFileSize. */
export function formatFileSize(bytes) {
    if (!bytes) {
        return "0 B"
    }
    if (bytes < 100) {
        return bytes + " B"
    }
    if (bytes < 100000) {
        return (Math.round(bytes / 100.0) / 10) + " kB"
    }
    if (bytes < 100000000) {
        return (Math.round(bytes / 100000.0) / 10) + " MB"
    }
    return (Math.round(bytes / 100000000.0) / 10) + " GB"
}
